import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.approval.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import { ClassicEditor, CKEditorPlugins, CoreTranslations } from "src/libs/portal/season/ckeditor";
import $ from "jquery";

@Component({
    selector: 'wiz-portal-lpsysadmin-approval-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.approval.item/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}

.ck-editor__editable {
  min-height: 300px;
}

:host ::ng-deep .ck-content .table {
  margin-left: 0 !important;
  margin-right: auto !important;
  text-align: left;
}
:host ::ng-deep .ck-content table {
  margin-left: 0 !important;
  margin-right: auto !important;
}

.last-arrow-hide:last-child {
  display: none;
}

@media print {
  :host {
    overflow: visible !important;
    height: auto !important;
  }
  .no-print {
    display: none !important;
  }
  .approval-final-view {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99999;
    background: white;
  }
  .print-area {
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    overflow: visible !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .print-area * {
    overflow: visible !important;
  }
  .print-area table {
    page-break-inside: auto;
  }
  .print-area tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .print-area .px-8 {
    padding-left: 1cm !important;
    padding-right: 1cm !important;
  }
}
@page {
  size: A4;
  margin: 1cm;
}`],
})
export class PortalLpsysadminApprovalItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() approval_id: string = '';
    @Input() listMode: string = '';

    @ViewChild('contentEditor')
    public editorElement: ElementRef;
    public editor: any;

    public approval: any = {};
    public loaded: boolean = false;
    public isNew: boolean = false;
    public users: any[] = [];
    public adminUsers: any[] = [];
    public funds: any[] = [];
    public companies: any[] = [];
    public templates: any[] = [];
    public comment: string = '';
    public hasSignature: boolean = false;
    public viewMode: string = 'edit'; // edit | final
    public itemTab: string = 'document'; // document | history
    public showPreview: boolean = false;

    // Search state for fund/company
    public fundSearch: string = '';
    public companySearch: string = '';
    public filteredFunds: any[] = [];
    public filteredCompanies: any[] = [];
    public showFundDropdown: boolean = false;
    public showCompanyDropdown: boolean = false;

    // Template selection
    public showTemplateSelector: boolean = false;

    public categories: any[] = [
        { key: 'internal', label: '내부' },
        { key: 'fund_invest', label: '조합/투자기업' },
        { key: 'finance', label: '자금' },
        { key: 'support', label: '지원사업' },
        { key: 'tips', label: 'TIPS' }
    ];

    public lineTypes: any[] = [
        { key: 'approval', label: '결재' },
        { key: 'consultation', label: '합의' }
    ];

    public statusMap: any = {
        draft: '임시저장',
        pending: '승인대기',
        approved: '종결',
        rejected: '반려',
        withdrawn: '회수',
        revision_requested: '보완요청'
    };

    public statusColorMap: any = {
        draft: 'bg-zinc-100 text-zinc-600',
        pending: 'bg-yellow-100 text-yellow-700',
        approved: 'bg-green-100 text-green-700',
        rejected: 'bg-red-100 text-red-700',
        withdrawn: 'bg-zinc-100 text-zinc-500',
        revision_requested: 'bg-orange-100 text-orange-700'
    };

    public lineStatusMap: any = {
        pending: '대기',
        approved: '승인',
        rejected: '반려',
        revision_requested: '보완요청',
        skipped: '건너뜀'
    };

    public lineStatusColorMap: any = {
        pending: 'text-zinc-500 bg-zinc-50 border-zinc-200',
        approved: 'text-green-700 bg-green-50 border-green-200',
        rejected: 'text-red-700 bg-red-50 border-red-200',
        revision_requested: 'text-orange-700 bg-orange-50 border-orange-200',
    };

    public async ngOnInit() {
        await this.service.init();
        this.isNew = this.approval_id === 'new';
        await this.loadMasterData();
        if (this.isNew) {
            this.showTemplateSelector = true;
        }
        await this.load();
    }

    public async loadMasterData() {
        const [usersRes, fundsRes, companiesRes, sigRes, tplRes] = await Promise.all([
            wiz.call("users"),
            wiz.call("funds"),
            wiz.call("companies"),
            wiz.call("check_signature"),
            wiz.call("templates")
        ]);
        if (usersRes.code == 200) {
            this.users = usersRes.data.rows || [];
            this.adminUsers = this.users;
        }
        if (fundsRes.code == 200) this.funds = fundsRes.data.rows || [];
        if (companiesRes.code == 200) this.companies = companiesRes.data.rows || [];
        if (sigRes.code == 200) this.hasSignature = sigRes.data.has_signature;
        if (tplRes.code == 200) this.templates = tplRes.data.rows || [];
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("load", { id: this.approval_id });
        if (code == 200) {
            this.approval = data.approval;
            if (!this.approval.lines) this.approval.lines = [];
            if (!this.approval.viewers) this.approval.viewers = [];
            if (!this.approval.attachments) this.approval.attachments = [];
            if (typeof this.approval.attachments === 'string') {
                try { this.approval.attachments = JSON.parse(this.approval.attachments); } catch (e) { this.approval.attachments = []; }
            }
            for (const line of this.approval.lines) {
                if (!line.type) line.type = 'approval';
            }
            if (this.approval.related_fund_id) {
                const fund = this.funds.find((f: any) => f.id === this.approval.related_fund_id);
                if (fund) this.fundSearch = fund.name;
            }
            if (this.approval.related_company_id) {
                const company = this.companies.find((c: any) => c.id === this.approval.related_company_id);
                if (company) this.companySearch = company.company_name;
            }
            if (this.approval.status === 'approved') {
                this.viewMode = 'final';
            }
        }
        this.loaded = true;
        await this.service.render();
        if (this.isEditable() && this.viewMode === 'edit') {
            await this.initEditor();
        }
    }

    // ===== CKEditor =====

    public async initEditor() {
        if (!this.editorElement) return;
        let element = this.editorElement.nativeElement;
        if ($(element).parent().find(".ck-content").length == 0) {
            let toolbar = 'heading | bold italic strikethrough underline | fontColor fontBackgroundColor | alignment | blockQuote | bulletedList numberedList | insertTable link horizontalLine | specialCharacters'.split(' ');
            this.editor = await ClassicEditor.create(element, {
                toolbar: { items: toolbar, shouldNotGroupWhenFull: true },
                removePlugins: ["MediaEmbedToolbar"],
                plugins: CKEditorPlugins,
                translations: [CoreTranslations],
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties'],
                    defaultProperties: {
                        alignment: 'left',
                        borderStyle: 'solid',
                        borderColor: '#d4d4d8',
                        borderWidth: '1px'
                    },
                    tableCellProperties: {
                        defaultProperties: {
                            borderStyle: 'solid',
                            borderColor: '#d4d4d8',
                            borderWidth: '1px',
                            padding: '6px 12px'
                        }
                    }
                }
            });
        }
        this.editor.data.set(this.approval.content || '');
    }

    // ===== Role Detection Methods =====

    public isRequester(): boolean {
        const userId = this.service.auth?.session?.id;
        if (!userId) return false;
        return this.approval.requester_id === userId;
    }

    public isInLine(): boolean {
        const userId = this.service.auth?.session?.id;
        if (!userId) return false;
        return (this.approval.lines || []).some((l: any) => l.approver_id === userId || l.approver?.id === userId);
    }

    public isViewer(): boolean {
        const userId = this.service.auth?.session?.id;
        if (!userId) return false;
        return (this.approval.viewers || []).some((v: any) => v.approver_id === userId || v.approver?.id === userId);
    }

    public isMyTurn(): boolean {
        if (this.approval.status !== 'pending') return false;
        const lines = this.approval.lines || [];
        const userId = this.service.auth?.session?.id;
        if (!userId) return false;
        for (const line of lines) {
            if (line.status === 'pending') {
                return line.approver_id === userId || line.approver?.id === userId;
            }
        }
        return false;
    }

    public getCurrentApproverName(): string {
        if (this.approval.status !== 'pending') return '';
        const lines = this.approval.lines || [];
        for (const line of lines) {
            if (line.status === 'pending') {
                return line.approver?.name || this.getUserName(line.approver_id);
            }
        }
        return '';
    }

    public getCurrentApproverOrder(): number {
        if (this.approval.status !== 'pending') return 0;
        const lines = this.approval.lines || [];
        for (const line of lines) {
            if (line.status === 'pending') {
                return line.order;
            }
        }
        return 0;
    }

    public isSuperAdmin(): boolean {
        return this.service.auth?.session?.membership === 'super_admin';
    }

    public isAdminEditing(): boolean {
        return this.isSuperAdmin() && this.approval.status === 'approved';
    }

    public isEditable(): boolean {
        if (this.isNew) return true;
        if (this.approval.status === 'draft') return true;
        if (['withdrawn', 'rejected', 'revision_requested'].includes(this.approval.status) && this.isRequester()) return true;
        if (this.isAdminEditing()) return true;
        return false;
    }

    public canResubmit(): boolean {
        return !this.isNew && ['withdrawn', 'rejected', 'revision_requested'].includes(this.approval.status) && this.isRequester();
    }

    // ===== Filtered Line Getters =====

    public getApprovalLines(): any[] {
        return (this.approval.lines || []).filter((l: any) => l.type !== 'consultation');
    }

    public getConsultationLines(): any[] {
        return (this.approval.lines || []).filter((l: any) => l.type === 'consultation');
    }

    public getLineIndex(line: any): number {
        return (this.approval.lines || []).indexOf(line);
    }

    // Template Selection
    public async selectTemplate(tpl: any) {
        this.approval.title = tpl.title;
        this.approval.content = tpl.content_template || '';
        this.approval.type = tpl.type || '';

        // Apply default approval line from template
        if (tpl.default_line) {
            let defaultLine = tpl.default_line;
            if (typeof defaultLine === 'string') {
                try { defaultLine = JSON.parse(defaultLine); } catch (e) { defaultLine = []; }
            }
            if (defaultLine && defaultLine.length > 0) {
                this.approval.lines = defaultLine.map((l: any, i: number) => ({
                    approver_id: l.approver_id,
                    order: i + 1,
                    status: 'pending',
                    type: 'approval'
                }));
            }
        }

        // Apply default viewers from template
        if (tpl.default_viewers) {
            let defaultViewers = tpl.default_viewers;
            if (typeof defaultViewers === 'string') {
                try { defaultViewers = JSON.parse(defaultViewers); } catch (e) { defaultViewers = []; }
            }
            if (defaultViewers && defaultViewers.length > 0) {
                this.approval.viewers = defaultViewers.map((v: any, i: number) => ({
                    approver_id: v.approver_id,
                    order: i + 1
                }));
            }
        }

        this.showTemplateSelector = false;
        await this.service.render();
        if (this.editor) {
            this.editor.data.set(this.approval.content);
        }
    }

    public skipTemplate() {
        this.showTemplateSelector = false;
        this.service.render();
    }

    // Fund Search
    public onFundSearchInput() {
        const q = this.fundSearch.toLowerCase().trim();
        if (q.length === 0) {
            this.filteredFunds = this.funds.slice(0, 20);
        } else {
            this.filteredFunds = this.funds.filter((f: any) => f.name.toLowerCase().includes(q)).slice(0, 20);
        }
        this.showFundDropdown = true;
        this.service.render();
    }

    public selectFund(fund: any) {
        this.approval.related_fund_id = fund.id;
        this.fundSearch = fund.name;
        this.showFundDropdown = false;
        this.service.render();
    }

    public clearFund() {
        this.approval.related_fund_id = '';
        this.fundSearch = '';
        this.showFundDropdown = false;
        this.service.render();
    }

    public onFundFocus() {
        this.filteredFunds = this.funds.slice(0, 20);
        this.showFundDropdown = true;
        this.service.render();
    }

    public onFundBlur() {
        setTimeout(() => {
            this.showFundDropdown = false;
            this.service.render();
        }, 200);
    }

    // Company Search
    public onCompanySearchInput() {
        const q = this.companySearch.toLowerCase().trim();
        if (q.length === 0) {
            this.filteredCompanies = this.companies.slice(0, 20);
        } else {
            this.filteredCompanies = this.companies.filter((c: any) => c.company_name.toLowerCase().includes(q)).slice(0, 20);
        }
        this.showCompanyDropdown = true;
        this.service.render();
    }

    public selectCompany(company: any) {
        this.approval.related_company_id = company.id;
        this.companySearch = company.company_name;
        this.showCompanyDropdown = false;
        this.service.render();
    }

    public clearCompany() {
        this.approval.related_company_id = '';
        this.companySearch = '';
        this.showCompanyDropdown = false;
        this.service.render();
    }

    public onCompanyFocus() {
        this.filteredCompanies = this.companies.slice(0, 20);
        this.showCompanyDropdown = true;
        this.service.render();
    }

    public onCompanyBlur() {
        setTimeout(() => {
            this.showCompanyDropdown = false;
            this.service.render();
        }, 200);
    }

    // Approval Line Management
    public addLine(type: string = 'approval') {
        if (!this.approval.lines) this.approval.lines = [];
        this.approval.lines.push({ approver_id: '', order: this.approval.lines.length + 1, status: 'pending', type: type });
        this.service.render();
    }

    public removeLine(index: number) {
        this.approval.lines.splice(index, 1);
        this.approval.lines.forEach((l: any, i: number) => l.order = i + 1);
        this.service.render();
    }

    // Viewer (공람) Management
    public addViewer() {
        if (!this.approval.viewers) this.approval.viewers = [];
        this.approval.viewers.push({ approver_id: '', order: this.approval.viewers.length + 1 });
        this.service.render();
    }

    public removeViewer(index: number) {
        this.approval.viewers.splice(index, 1);
        this.approval.viewers.forEach((v: any, i: number) => v.order = i + 1);
        this.service.render();
    }

    // Helpers
    public getUserName(userId: string) {
        const user = this.users.find((u: any) => u.id === userId);
        return user ? user.name : '-';
    }

    public getUserTitle(userId: string) {
        const user = this.users.find((u: any) => u.id === userId);
        return user ? user.title || '' : '';
    }

    public getCategoryLabel(key: string): string {
        const cat = this.categories.find((c: any) => c.key === key);
        return cat ? cat.label : key;
    }

    public getLineTypeLabel(type: string): string {
        const lt = this.lineTypes.find((t: any) => t.key === type);
        return lt ? lt.label : '결재';
    }

    public needsRelatedEntity(): boolean {
        const cat = this.approval.category;
        return cat === 'fund_invest' || cat === 'tips';
    }

    // File Attachments
    public async onFileSelect(event: any) {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        let aid = this.approval_id;
        if (this.isNew || aid === 'new') {
            await this.save(true);
            aid = this.approval_id;
            if (!aid || aid === 'new') return;
        }

        for (let i = 0; i < files.length; i++) {
            const formData = new FormData();
            formData.append('file', files[i]);
            formData.append('approval_id', aid);
            const response = await fetch(`/wiz/api/${wiz.namespace}/upload`, {
                method: 'POST',
                body: formData
            });
            const result = await response.json();
            if (result.code === 200) {
                if (!this.approval.attachments) this.approval.attachments = [];
                this.approval.attachments.push(result.data.file);
            }
        }
        event.target.value = '';
        await this.save(true);
        await this.service.render();
    }

    public async removeAttachment(index: number) {
        const file = this.approval.attachments[index];
        if (!file) return;
        await wiz.call("remove_file", {
            approval_id: this.approval_id,
            stored_name: file.stored_name
        });
        this.approval.attachments.splice(index, 1);
        await this.save(true);
        await this.service.render();
    }

    public downloadAttachment(file: any) {
        const url = `/wiz/api/${wiz.namespace}/download?approval_id=${this.approval_id}&stored_name=${encodeURIComponent(file.stored_name)}&original_name=${encodeURIComponent(file.original_name)}`;
        window.open(url, '_blank');
    }

    public formatFileSize(bytes: number): string {
        if (bytes < 1024) return bytes + 'B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'KB';
        return (bytes / (1024 * 1024)).toFixed(1) + 'MB';
    }

    // Save
    public async save(silent: boolean = false) {
        if (this.editor) {
            this.approval.content = this.editor.data.get();
        }
        const data: any = { ...this.approval };
        data.lines = JSON.stringify(data.lines || []);
        data.viewers = JSON.stringify(data.viewers || []);
        data.attachments = JSON.stringify(data.attachments || []);
        const { code, data: res } = await wiz.call("save", data);
        if (code == 200) {
            if (!silent) this.service.alert.success("저장되었습니다.");
            if (this.isNew && res.id) {
                this.approval_id = res.id;
                this.approval.id = res.id;
                this.isNew = false;
                await this.service.href(`/admin/system/approval/${res.id}`);
            } else if (!silent) {
                await this.load();
            }
        } else {
            if (!silent) this.service.alert.error(res?.message || "저장 실패");
        }
    }

    // Preview & Submit
    public async previewBeforeSubmit() {
        if (this.editor) {
            this.approval.content = this.editor.data.get();
        }
        if (!this.approval.title?.trim()) {
            this.service.alert.error("제목을 입력해주세요.");
            return;
        }
        if (!this.approval.lines?.length || !this.approval.lines.some((l: any) => l.approver_id)) {
            this.service.alert.error("결재자를 추가해주세요.");
            return;
        }
        // Save silently without redirect
        const data: any = { ...this.approval };
        data.lines = JSON.stringify(data.lines || []);
        data.viewers = JSON.stringify(data.viewers || []);
        data.attachments = JSON.stringify(data.attachments || []);
        const { code, data: res } = await wiz.call("save", data);
        if (code == 200) {
            if (this.isNew && res.id) {
                this.approval_id = res.id;
                this.approval.id = res.id;
                this.isNew = false;
            }
            this.showPreview = true;
            await this.service.render();
        } else {
            this.service.alert.error(res?.message || "저장 실패");
        }
    }

    public async confirmSubmit() {
        this.showPreview = false;
        await this.service.render();
        const { code, data } = await wiz.call("submit", { id: this.approval_id });
        if (code == 200) {
            this.service.alert.success("상신되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(data?.message || "상신 실패");
        }
    }

    public async closePreview() {
        this.showPreview = false;
        await this.service.render();
    }

    public async submit() {
        if (this.editor) {
            this.approval.content = this.editor.data.get();
        }
        const isResubmit = this.canResubmit();
        const res = await this.service.alert.show({
            title: isResubmit ? '재상신' : '결재 상신',
            message: isResubmit ? '수정된 내용으로 재상신하시겠습니까?' : '결재를 상신하시겠습니까?',
            action: isResubmit ? '재상신' : '상신',
            actionBtn: 'success',
            status: 'success'
        });
        if (!res) return;
        await this.save(true);
        const { code, data } = await wiz.call("submit", { id: this.approval_id });
        if (code == 200) {
            this.service.alert.success(isResubmit ? "재상신되었습니다." : "상신되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(data?.message || "상신 실패");
        }
    }

    public async approve() {
        if (!this.hasSignature) {
            this.service.alert.error("서명이 등록되어 있지 않습니다. 조합원관리 > 내 정보에서 서명을 등록해주세요.");
            return;
        }
        const res = await this.service.alert.show({
            title: '결재 승인',
            message: '서명이 자동 첨부됩니다. 승인하시겠습니까?',
            action: '승인',
            actionBtn: 'success',
            status: 'success'
        });
        if (!res) return;
        const { code, data } = await wiz.call("approve", { id: this.approval_id, comment: this.comment });
        if (code == 200) {
            this.service.alert.success("승인되었습니다.");
            this.comment = '';
            await this.load();
        } else {
            this.service.alert.error(data?.message || "승인 실패");
        }
    }

    public async reject() {
        if (!this.comment.trim()) {
            this.service.alert.error("반려 사유를 입력해주세요.");
            return;
        }
        const res = await this.service.alert.show({
            title: '결재 반려',
            message: '반려하시겠습니까?',
            action: '반려',
            actionBtn: 'error',
            status: 'error'
        });
        if (!res) return;
        const { code, data } = await wiz.call("reject", { id: this.approval_id, comment: this.comment });
        if (code == 200) {
            this.service.alert.success("반려되었습니다.");
            this.comment = '';
            await this.load();
        } else {
            this.service.alert.error(data?.message || "반려 실패");
        }
    }

    public async requestRevision() {
        if (!this.comment.trim()) {
            this.service.alert.error("보완 사유를 입력해주세요.");
            return;
        }
        const res = await this.service.alert.show({
            title: '보완요청',
            message: '기안자에게 보완을 요청하시겠습니까?',
            action: '보완요청',
            actionBtn: 'error',
            status: 'error'
        });
        if (!res) return;
        const { code, data } = await wiz.call("request_revision", { id: this.approval_id, comment: this.comment });
        if (code == 200) {
            this.service.alert.success("보완요청되었습니다.");
            this.comment = '';
            await this.load();
        } else {
            this.service.alert.error(data?.message || "보완요청 실패");
        }
    }

    public async withdraw() {
        const res = await this.service.alert.show({
            title: '결재 회수',
            message: '상신을 회수하시겠습니까?',
            action: '회수',
            actionBtn: 'error',
            status: 'error'
        });
        if (!res) return;
        const { code, data } = await wiz.call("withdraw", { id: this.approval_id });
        if (code == 200) {
            this.service.alert.success("회수되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(data?.message || "회수 실패");
        }
    }

    public async deleteApproval() {
        const res = await this.service.alert.show({
            title: '삭제',
            message: '결재 문서를 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!res) return;
        const { code, data } = await wiz.call("delete", { id: this.approval_id });
        if (code == 200) {
            this.service.alert.success("삭제되었습니다.");
            await this.service.href('/admin/system/approval');
        } else {
            this.service.alert.error(data?.message || "삭제 실패");
        }
    }

    public goBack() {
        const mode = this.listMode || 'pending';
        this.service.href(`/admin/system/approval/${mode}`);
    }

    public async switchItemTab(tab: string) {
        this.itemTab = tab;
        await this.service.render();
    }

    public async toggleView() {
        if (this.viewMode === 'edit' && this.editor) {
            this.approval.content = this.editor.data.get();
            try { this.editor.destroy(); } catch (e) { }
            this.editor = null;
        }
        this.viewMode = this.viewMode === 'final' ? 'edit' : 'final';
        await this.service.render();
        if (this.viewMode === 'edit' && this.isEditable()) {
            await this.initEditor();
        }
    }

    public printFinal() {
        window.print();
    }

    // Admin: update line acted_at times
    public async saveAdminTimes() {
        const lines = (this.approval.lines || []).map((l: any) => ({
            id: l.id,
            acted_at: l.acted_at || ''
        }));
        const { code, data } = await wiz.call("admin_update_times", {
            id: this.approval_id,
            created: this.approval.created || '',
            lines: JSON.stringify(lines)
        });
        if (code == 200) {
            this.service.alert.success("시간이 변경되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(data?.message || "시간 변경 실패");
        }
    }
}

export default PortalLpsysadminApprovalItemComponent;